<template>
  <div>
    <h2 class="step-name">Email Notifications</h2>

    <div class="step-section">
      <div v-for="notification in getFieldValue('notifications')" :key="notification.slug">
        <label :class="notification.marked || notification.auto_generated ? '' : 'comment-disabled'">
          <span
            class="glyphicon glyphicon-envelope"
            aria-hidden="true"
            data-toggle="tooltip"
            data-placement="top"
            title="Email might be generated"
          ></span>
          {{ notification.name }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters } from 'vuex'

export default {
  name: 'EmailNotifications',
  mixins: [baseComponent],
  mounted() {
    this.toggleNotifications()
  },
  computed: {
    ...mapGetters('currentConsult', ['drugs_allocated']),
  },
  methods: {
    hasScourAllocationsFor: function (farm) {
      let svids = this.getFieldValue('SCOUR_VAX_PRODUCT_IDS', 'PreventiveHealthAndVacination')
      return this.drugs_allocated[farm.id].some(
        (allocation) => allocation.par_qty > 0 && svids.includes(allocation.drug_allocation_product)
      )
    },
    toggleNotifications: function () {
      // scour vaccine ent handled here because it can be triggered from
      // PreventiveHealthAndVacination or DrugAllocations steps
      let farms = this.getFieldValue('FARMS', 'PreventiveHealthAndVacination')
      let scourFieldsToCheck = farms.map((farm) => `farm_${farm.id}-wants_scour_vaccine`)

      this.setEmailNotification({
        slug: 'scour-vaccine-email',
        value:
          scourFieldsToCheck.some(
            (fieldName) => this.getFieldValue(fieldName, 'PreventiveHealthAndVacination') == 'Yes'
          ) || farms.some((farm) => this.hasScourAllocationsFor(farm)),
      })
      // END scour vaccine
    },
  },
}
</script>
